export enum InsightTemplate {
	AccessEntityAssignedRow,
	AccessEntityOptionRow,
	CategoryAdminAssignedRow
}
